/**
 * Variant consequence type identifiers
 */
export const VARIANT_CONSEQUENCE_TYPES = {
  MISSENSE: 'missense_variant',
  INFRAME_DELETION: 'inframe_deletion',
  INFRAME_INSERTION: 'inframe_insertion',
} as const;

/**
 * Common notification messages
 */
export const NOTIFICATION_MESSAGES = {
  SUCCESS: 'Success!',
  ERROR: 'Error',
  INFO: 'Info',
  CLINVAR_GENE_DISTRIBUTION_LOAD_FAILED:
    'Failed to load ClinVar gene distribution. Please try again.',
  CLINICAL_INTERPRETATION_UPDATED:
    'Clinical interpretation updated successfully',
  STAGE_UPDATED: 'Stage has been updated',
  CONFIRMATION_CREATED: 'Confirmation created successfully',
  CONFIRMATION_ALREADY_EXISTS:
    'You have already confirmed this variant assessment',
  ARGUMENTS_RECALCULATED:
    'Auto-calculated arguments have been recalculated successfully.',
  RECALCULATE_ARGUMENTS_FAILED:
    'Failed to recalculate arguments. Please try again.',
  COMMENT_UPDATED: 'Comment updated successfully.',
  COMMENT_UPDATE_FAILED: 'Failed to update comment.',
  COMMENT_DELETED: 'Comment deleted successfully.',
  COMMENT_DELETE_FAILED: 'Failed to delete comment.',
  PREDICTION_TOOL_UPDATED: 'Tool updated successfully.',
  PREDICTION_TOOL_UPDATE_FAILED: 'Failed updating prediction tool.',
  PREDICTION_TOOL_SAVED: 'Prediction tool saved.',
  PREDICTION_TOOL_SAVE_FAILED: 'Failed saving prediction tool.',
  VARIANT_ID_MISSING: 'Variant id is missing',
  MAX_CREDIBLE_AF_UPDATED:
    'Maximum credible & estimated population AF for the selected phenotype has been updated.',
  REFERENCE_SAVED: 'Reference has been saved successfully',
  REPORT_PANEL_UPDATED: 'Report panel for sample updated successfully',
  REPORT_CATEGORY_UPDATED: 'Report category updated successfully.',
  DATABASE_CREATED: 'Database created successfully.',
  DATABASE_UPDATED: 'Database updated successfully.',
  DATABASE_UPDATE_FAILED: 'Database update failed. Please try again.',
  DIAGNOSTICUM_SAMPLE_ID_INVALID:
    'The sample ID for Diagnosticum users must consist of exactly 9 digits.',
  ZYGOSITY_UPDATED: 'Sample zygosity updated successfully.',
  ZYGOSITY_UPDATE_FAILED: 'Failed to update zygosity. Please try again.',
  REFRESH_TASK_NOT_STARTED:
    'The refresh was acknowledged but no background task was started.',
  REFRESH_TASK_START_FAILED:
    'Failed to start the refresh task. Please try again.',
  REFRESH_ALREADY_RUNNING:
    'A refresh and recalculation is already running for this variant.',
  SNAPSHOT_PREPARATION_FAILED: 'Failed to prepare the Interpretation snapshot.',
  SNAPSHOT_CREATE_FAILED: 'Snapshot could not be created',
  SNAPSHOT_CREATE_FAILED_DESCRIPTION:
    'The refresh started, but the Interpretation snapshot could not be saved.',
  PROTEIN_DOMAIN_UPDATED: 'Protein domain regulatory updated successfully',
  CLINVAR_RECORD_UPDATED: 'ClinVar record updated successfully',
  POPULATION_AF_UPDATED:
    'Allele frequency in population database gnomAD updated successfully',
  SNAPSHOT_SAVED: 'Snapshot saved',
  SNAPSHOT_SAVED_DESCRIPTION:
    'The current interpretation data was saved successfully.',
  SNAPSHOT_SAVE_FAILED: 'Snapshot could not be saved',
  SNAPSHOT_SAVE_FAILED_DESCRIPTION:
    'Please try again after the interpretation data has loaded.',
  SNAPSHOT_CREATION_FAILED: 'Snapshot could not be created',
  SNAPSHOT_CREATION_FAILED_DESCRIPTION:
    'The Interpretation stage was revised, but its automatic snapshot could not be saved.',
  SNAPSHOT_REFRESH_CREATION_FAILED_DESCRIPTION:
    'The variant data was refreshed, but the Interpretation snapshot could not be saved.',
  VARIANT_DATA_REFRESHED:
    'Variant data refreshed and arguments recalculated successfully.',
  VARIANT_DATA_REFRESH_FAILED:
    'Failed to refresh variant data and recalculate arguments. Please try again.',
} as const;

/**
 * Data source fallback strings for version history display
 *
 * These are used when versioning info is not available from the API
 */
export const DATA_SOURCE_FALLBACKS = {
  ENSEMBL: 'Data fetched from Ensembl REST API v.15.9',
  BROAD: 'Data fetched from Broad Institute, local API server',
} as const;
